module.exports = __webpack_public_path__ + "static/wordpress6-40426654aeb829fa8fd3e63872d7bbe5.png";